<div class="SidePanelMobile">
  <zip-button
    class="SidePanelMobile__Button"
    [config]="{
      level: 'medium',
      content: 'Overview',
      size: 'fullWidth'
    }"
    (zipButtonClicked)="isOverviewModalOpen = !isOverviewModalOpen"
  >
  </zip-button>

  <side-panel-overview-modal
    [(isMobileOverviewOpen)]="isOverviewModalOpen"
    [context]="memberContext"
    [mobileConfig]="config"
    (isMobileOverviewOpenChange)="isOverviewModalOpen = $event"
  ></side-panel-overview-modal>
</div>
